import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Button, Container, Stack, Typography } from '@mui/material';
import '../Styles/product.css';
import { FcDownload } from 'react-icons/fc';
import { useNavigate } from 'react-router-dom';
import { FaClipboardList, FaEdit } from 'react-icons/fa';
import axios from 'axios';
import { saveAs } from 'file-saver'
import { ToastContainer, toast } from 'react-toastify';
import TableData from '../components/common/TableData';

import { getShiprocketManifest, printManifest } from '../Servies/AdmiServices';

export default function ShiprocketManifest()  {
  const headers = ['Courier Name', 'Date', 'Count',  'Print'];
  const navigate = useNavigate();
  const [courier, setCouriers] = useState([]);

  // ConditioConnally render the product list based on the form submission
  const handleEditEdit = (courseId) => {
    navigate(`/dashboard/CreateCourse?courseId=${courseId}`);
  };

  const handleStructure = (courseId) => {
   
    navigate(`/dashboard/CourseStructure?courseId=${courseId}`);
  };
  const getManifestDataCouriers = () => {
    getShiprocketManifest()
      .then((res) => {
        console.log(res)
        setCouriers(res?.data.response);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getManifestDataCouriers();
  }, []);


  const handleManifestClick = (courierId, courierName, date) => {
      const data = {
        "courier_id":courierId,
        "partner_id": 3,
        "date":date
      }
      console.log("printManifest:", data)
      printManifest(data).then((res) => {
        console.log(res.data)
  
        if(res.data.status ==='SUCCESS'){
           toast.success("Manifest Generated");
            downloadLabelPDF(res.data.response.manifest_url, courierName, "manifest")
        }else{
           toast.success("Manifest not found");
  
        }
  
      })
    }
     const downloadLabelPDF = async (labelUrl, courierName, name) => {
        try {
          const response = await axios({
            url: labelUrl,
            method: 'GET',
            responseType: 'blob',
          });
         // Replace spaces in the customer name with underscores
          const sanitizedCustomerName = courierName.replace(/\s+/g, "_");
    
          // Define the filename dynamically
          const filename = `${sanitizedCustomerName}_${name}.pdf`;
          const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
          saveAs(pdfBlob, filename);
        } catch (error) {
          console.error('Error downloading the PDF:', error);
        }
      };
  const specificColumns = courier.map((item) => {
    return {
      'Courier Name': item.dispatchedby,
      'Date': item.createdDate,
       'Count': item.dispatchCount,
      'Print': (
        <Button 
          variant="contained" 
          color="primary" 
          onClick={() => handleManifestClick(item.courierId, item.dispatchedby, item.createdDate)}
        >
          Manifest
        </Button>
        )
   
    };
  });

  const onCreate = () => {
    navigate('/dashboard/CreateCourse');
  };

  return (
    <>
      <ToastContainer />
      <Helmet>
        <title> Dashboard: Courses </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Shiprocket Manifest
          </Typography>
          
        </Stack>

        {/* Render the table component */}
        <TableData data={specificColumns} headers={headers} rowsPerPageOptions={[5, 10, 20]} />
      </Container>
    </>
  );
}
